var map = {
	"./fortuneIcon.svg": 702,
	"./fortuneIconL.svg": 703,
	"./helpdeskIcon.svg": 704,
	"./helpdeskIconL.svg": 705,
	"./homeIcon.svg": 706,
	"./homeIconLarge.svg": 707,
	"./jackpotIcon.svg": 708,
	"./logo.svg": 709,
	"./logoSmall.svg": 710,
	"./loyaltyIcon.svg": 711,
	"./mobileAppIcon.svg": 712,
	"./profileIcon.svg": 713,
	"./questIcon.svg": 714,
	"./questsIcon.svg": 715,
	"./rewardLineupIcon.svg": 716,
	"./searchIcon.svg": 717,
	"./searchIconLarge.svg": 718,
	"./signOutIcon.svg": 719,
	"./star.svg": 720,
	"./tournamentIcon.svg": 721,
	"./tournamentLargeIcon.svg": 722,
	"./vipIcon.svg": 723,
	"./wheelIcon.svg": 724,
	"./wheelIconL.svg": 725,
	"./wheelIconMobile.svg": 726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 701;